'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _radio = require('antd/lib/radio');

var _radio2 = _interopRequireDefault(_radio);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _connectField = require('uniforms/connectField');

var _connectField2 = _interopRequireDefault(_connectField);

var _filterDOMProps = require('uniforms/filterDOMProps');

var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);

var _wrapField = require('./wrapField');

var _wrapField2 = _interopRequireDefault(_wrapField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Radio_ = function Radio_(props) {
    return (0, _wrapField2.default)(props, _react2.default.createElement(
        _radio2.default.Group,
        (0, _extends3.default)({
            disabled: props.disabled,
            name: props.name,
            onChange: function onChange(event) {
                return props.onChange(event.target.value);
            },
            value: props.value
        }, (0, _filterDOMProps2.default)(props)),
        props.allowedValues.map(function (value) {
            return _react2.default.createElement(
                _radio2.default,
                {
                    key: value,
                    value: value,
                    style: {
                        display: 'block',
                        height: '30px',
                        lineHeight: '30px'
                    }
                },
                props.transform ? props.transform(value) : value
            );
        })
    ));
};

Radio_.displayName = 'Radio';

exports.default = (0, _connectField2.default)(Radio_);


//////////////////
// WEBPACK FOOTER
// ./~/uniforms-antd/RadioField.js
// module id = 630
// module chunks = 35783957827783 65974612472484